/**
 * כותרת עמוד אחידה לפאנל — DESIGN.md 8.1: "H1 + תיאור שורה + כפתור פעולה
 * ראשי בקצה (end)". `action` הוא `ReactNode` חופשי — פעמים רבות `<Link>` עם
 * `.btn-cta`, לפעמים כפתור עם `onClick`.
 */
import type { ReactNode } from 'react';

interface AdminPageHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function AdminPageHeader({ title, description, action }: AdminPageHeaderProps) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <h1 className="text-2xl font-bold">{title}</h1>
        {description && <p className="text-muted mt-1 text-sm">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
